import { render, staticRenderFns } from "./technology_data.vue?vue&type=template&id=af9c96f6&scoped=true&"
import script from "./technology_data.vue?vue&type=script&lang=js&"
export * from "./technology_data.vue?vue&type=script&lang=js&"
import style0 from "./technology_data.vue?vue&type=style&index=0&id=af9c96f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af9c96f6",
  null
  
)

export default component.exports